export const SERVER_API = "/api"
export const UPLOAD_API = '/api';
export const UPLOAD_PATH = '/mpp/image/upload';
export const SOCKET_API = 'api';
export const WEB_JS_KEY = '0a340fa72e11df852e1769b6d0b7be88';
export const SECURITY_JS_CODE = '7617f46632f2e768b17a79ed50e692cd';
// 商品
export const PRODUCT = [{prop: 'productPic',label: '商品封面',img: 'img'},{prop: 'productName',label: '商品',img: '',children:[{prop: 'productName',label: '名称',},{prop: 'productNumber',label:'货号'}]},{prop: 'shopPrice',label: '价格',img: '',children:[{prop:'shopPrice',label:'商品价格'},{prop:'marketPrice',label: '市场价格'},{prop:'supplyPrice',label: '供货价格'}]}];
export const PRODUCT_SEARCH = [{prop: 'productName',label: '商品名称'}]
export const PRODUCT1 = [{prop: 'productPic',label: '商品封面',img: 'img'},{prop: 'productName',label: '商品',img: '',children:[{prop: 'productName',label: '名称',},{prop: 'productNumber',label:'货号'}]},{prop: 'shopPrice',label: '价格',img: '',children:[{prop:'shopPrice',label:'商品价格'},{prop:'marketPrice',label: '市场价格'},{prop:'supplyPrice',label: '供货价格'}]},{prop: 'category.categoryName',label: '分类',img: 'twolabel'}];
export const PRODUCT_SEARCH1 = [{prop: 'productName',label: '商品名称'}]
// 用户
export const USER = [{prop: 'userName',label: '账号'},{prop: 'userMobile',label: '手机号'},{prop: 'userNickname',label: '昵称'},{prop: 'userRealname',label: '姓名'}]
export const USER_SEARCH = [{prop: 'userName',label: '账号'},{prop: 'userMobile',label: '手机号'}]
// 门店
export const STORE = [{prop:'storeName',label: '门店名称'},{prop: 'storeLogo',label: '门店图片',img: 'img'},{prop:'contactPerson',label: '联系人'},{prop:'contactPhone',label: '联系电话'}]
export const STORE_SEARCH = [{prop: 'storeName',label: '门店名称'},{prop: 'userName',label: '账号'},{prop:'userMobile',label: '手机号'},{prop:'licenseName',label: '营业执照名称'}]
export const ORDERCODE = [{prop:'orderId',label: '订单ID'},{prop: 'orderCode',label: '订单编码'}]
export const ORDERCODE_SEARCH = [{prop: 'orderCode',label: '订单编码'}]
// 品牌
export const BRAND = [{prop: 'brandLogo',label: '品牌LoGo',img: 'img'},{prop: 'brandName',label: '品牌名称',}]
export const BRAND_SEARCH = [{prop: 'brandName',label: '品牌名称'}]
// 店铺
export const SHOP = [{prop: 'shopLogo',label: '店铺Logo',img: 'img'},{prop: 'shopName',label: '店铺名称'}]
export const SHOP_SEARCH = [{prop:'shopName',label: '店铺名称'}]
// 视频
export const VIDEO = [{prop: 'videoPic',label: '照片'},{prop: 'videoDesc',label: '视频描述'},{prop: 'createTime',label: '时间'}]
export const VIDEO_SEARCH = [{prop: 'videoDesc',label: '视频描述'}]
// 推广人
export const PROMOTER = [{prop: 'promoterHeader',label: '推广人头像',img: 'img'},{prop: 'promoterName',label: '推广人姓名'}]
export const PROMOTER_SEARCH = [{prop: 'promoterName',label: '推广人姓名'}]
export const HOTEL = [{prop: 'hotelLogo',label: '酒店LoGo',img: 'img'},{prop: 'hotelName',label: '酒店名称'}]
export const HOTEL_SEARCH = [{prop: 'hotelName',label: '酒店名称'}]
export const APPMENU = [{prop: 'menuName',label: '名称'},{prop: 'menuIcon',label: '图标'},{prop: 'menuLink',label: '链接'}]
export const APPMENU_SEARCH = [{prop: 'menuName',label: '名称'}]
export const ROOM = [{prop: 'roomPic',label: '房间图片',img: 'img'},{prop: 'roomName',label: '房间名称'}]
export const ROOM_SEARCH = [{prop: 'roomName',label: '房间名称'}]
export const PERSON = [{prop: 'lineName',label: '配送路线'},{prop: 'personName',label: '配送人姓名'},{prop: 'personHeader',label: '配送人头像',img: 'img'},{prop: 'personMobile',label: '配送人电话'}]
export const PERSON_SEARCH = [{prop: 'personName',label: '配送人姓名'}]
export const SORTING = [{prop: 'warehouseName',label: '仓库名称'},{prop: 'personHeader',label: '分拣人头像',img: 'img'},{prop: 'personName',label: '分拣员姓名'},{prop: 'personMobile',label: '分拣人电话'}]
export const SORTING_SEARCH = [{prop: 'personName',label: '配送人姓名'}]
export const PACKET = [{prop: 'totalAmount',label: '红包总金额'},{prop: 'totalPacket',label: '红包总个数'}]
export const PACKET_SEARCH = [{prop: 'totalAmount',label: '红包总金额'}]
export const COUPON = [{prop: 'couponName',label: '优惠券名称'},{prop: 'couponMoney',label: '优惠券额度'}]
export const COUPON_SEARCH = [{prop: 'couponName',label: '优惠券名称'}]
export const CARD = [{prop: 'expiredTime',label: '有效时间(年)'},{prop: 'money',label: '卡片价值'}]
export const CARD_SEARCH = [{prop:'money',label: '卡片价值'}]
export const SHOPCARD = [{prop: 'coverPic',label: '卡片封面',img: 'img'},{prop: 'money',label: '卡片额度'}]
export const SHOPCARD_SEARCH = [{prop:'money',label: '卡片额度'}]
export const SHOPCARD1 = [{prop: 'coverPic',label: '卡片封面',img: 'img'},{prop: 'cardName',label: '商品名称'}]
export const SHOPCARD_SEARCH1 = [{prop:'cardName',label: '商品名称'}]
// 优质采分类
export const YOUZHICAI_CATEGORY = [{prop: 'cateId',label: '分类ID'},{prop: 'cateName',label: '分类名称'}];
export const YOUZHICAI_SEARCH = [{prop: 'cateName',label: '分类名称'}]
export const CUSTOMER = [
    {
        prop:'customerName',
        label:'客服名称'
    },
    {
        prop:'customerHeader',
        label:'客服头像',
        img:'img'
    },
    {
        prop:'greeting',
        label:'问候语'
    },
    {
        prop:'companyName',
        label:'公司名称'
    }
]
export const CUSTOMER_SEARCH = [
    {
        prop:'customerName',
        label:'客服名称'
    },
    {
        prop:'companyName',
        label:'公司名称'
    }
]
export const TASKFANS = [
    {
        prop: 'userId',
        label: '用户',
    },
    {
        prop: 'offerPrice',
        label: '涨关注出价金额'
    },
    {
        prop: 'targetFansNumber',
        label: '需要涨关注数量'
    },
    {
        prop: 'finishTaskNumber',
        label: '已接单任务数量'
    },
    {
        prop: 'acceptFansRequire',
        label: '接单人粉丝要求'
    },
    {
        prop: 'acceptWorksRequire',
        label: '接单人任务要求'
    },
    {
        prop: 'taskAccount',
        label: '任务要关注的账号'
    },
    {
        prop: 'taskTarget',
        label: '任务要跳转的位置'
    },
]
export const TASKFANS_SEARCH = [
    {
        prop: 'offerPrice',
        label: '涨关注出价金额'
    },
    {
        prop: 'targetFansNumber',
        label: '需要涨关注数量'
    },
    {
        prop: 'acceptFansRequire',
        label: '接单人粉丝要求'
    },
    {
        prop: 'acceptWorksRequire',
        label: '接单人任务要求'
    },
    {
        prop: 'taskAccount',
        label: '任务要关注的账号'
    },
    {
        prop: 'taskTarget',
        label: '任务要跳转的位置'
    }
]
export const TASKFOLLOW = [
    {
        prop: 'userId',
        label: '用户'
    },
    {
        prop: 'platform',
        label: '平台'
    },
    {
        prop: 'taskName',
        label: '任务标题'
    },{
        prop: 'roomSize',
        label: '房间容纳人数'
    },
    {
        prop: 'currentSize',
        label: '房间已进人数'
    },
    {
        prop: 'status',
        label: '房间状态'
    },
    {
        prop: 'deadline',
        label: '截止时间'
    }
]
export const TASKFOLLOW_SEARCH = [
    {
        prop: 'taskName',
        label: '任务标题'
    },
    {
        prop: 'roomSize',
        label: '房间容纳人数'
    },
    {
        prop: 'currentSize',
        label: '房间已进人数'
    }
]
export const MEDIA = [
    {
        prop: 'userId',
        label: '用户'
    },
    {
        prop: 'videoUrls',
        label: '视频链接'
    },
    {
        prop: 'indexUrl',
        label: '主页链接'
    },
    {
        prop: 'nickName',
        label: '账号'
    },
    {
        prop: 'accountLogo',
        label: '账号LoGo',
        img: 'img'
    },
    {
        prop: 'isDefault',
        label: '是否默认'
    },
    {
        prop: 'createTime',
        label: '创建时间'
    }
]
export const MEDIA_SEARCH = [
    {
        prop: 'nickName',
        label: '账号'
    },
    {
        prop: 'videoUrls',
        label: '视频链接'
    },
    {
        prop: 'indexUrl',
        label: '主页链接'
    }
]
export const SHOPPRODUCTGROUPBUY = [{prop: 'productName',label: '拼团商品名称'},{prop: 'productPic',label: '拼团商品图片图片', img: 'img'},{prop: 'groupbuyPrice',label: '拼团商品价格'},{prop: 'groupNumber',label: '拼团人数'},{prop: 'virtualNumber', label: '虚拟人数'}]
export const SHOPPRODUCTGROUPBUY_SEARCH = [{prop:'productName',label: '拼团商品名称'}]
export const EDUTEACHER = [{prop: 'teacherName',label: '教师姓名'},{prop: 'teacherPic',label: '教师头像', img: 'img'},{prop: 'teacherProfile',label: '教师简介'},{prop: 'teacherMajor',label: '教师专业'}]
export const EDUTEACHER_SEARCH = [{prop: 'teacherName',label: '教师姓名'}]
export const EDUCLASSCOURSE = [{prop: 'courseName',label: '课程名称'},{prop: 'coursePic',label: '课程图片', img: 'img'},{prop: 'coursePrice',label: '课程价格'},{prop: 'originalPrice',label: '课程原价'},{prop: 'courseIntro',label: '课程简介'}]
export const EDUCLASSCOURSE_SEARCH = [{prop: 'courseName',label: '课程名称'}]
export const EDUCLASSMERTERIAL = [{prop: 'fileName',label: '文件名称'},{prop: 'fileUrl',label: '文件URL'},{prop: 'fileTag',label: '文件标签'}]
export const EDUCLASSMERTERIAL_SEARCH = [{prop: 'fileName',label: '文件名称'}]
export const EDUCLASSCOURSEVIDEO = [{prop: 'videoName',label: '视频名称'},{prop: 'videoCover',label: '视频封面', img: 'img'},{prop: 'videoSize',label: '视频大小'},{prop: 'videoUrl',label: '视频地址'},{prop: 'videoSecond',label: '视频时长'}]
export const EDUCLASSCOURSEVIDEO_SEARCH = [{prop: 'videoName',label: '视频名称'}]
export const EDUCLASSCOURSTESTPAPER = [{prop: 'exerciseName',label: '题干'},{prop: 'category.categoryName',label: '分类',img: 'twolabel'},{prop: 'subject.subjectName',label: '科目',img: 'twolabel'}]
export const EDUCLASSCOURSTESTPAPER_SEARCH = [{prop: 'exerciseName',label: '题干'},{prop: 'exerciseType',label: '题型',sign: 'hidden'}]
export const EDUCLASSCOURSEROOM = [{prop: 'streamName',label: '直播名称'},{prop: 'startTime',label: '开始时间'},{prop: 'endTime',label: '结束时间'},{prop: 'streamTag',label: '标签'}]
export const EDUCLASSCOURSEROOM_SEARCH = [{prop: 'streamName',label: '直播名称'}]
export const EDUKNOWLEDGE = [{prop: 'knowledgeName',label: '知识点'},{prop: 'sort',label: '排序'},{prop: 'parentId',label: '父ID'}]
export const EDUKNOWLEDGE_SEARCH = [{prop: 'knowledgeName',label: '知识点'}]
export const TEMPLATEUSER = [{prop: 'userName',label: '账号'},{prop: 'userPass',label: '密码'},{prop: 'apiPass',label: 'API密码'},{prop: 'userMobile',label: '用户电话'}]
export const TEMPLATEUSER_SEARCH = [{prop: 'userName',label: '账号'}]
export const SMSAPI = [{prop: 'apiName',label: '接口名称'},{prop: 'apiUrl',label: '接口网址'},{prop: 'apiUser',label: '接口账号'},{prop: 'apiPwd',label: '接口密码'},{prop: 'apiMethod',label: '调用方法'}]
export const SMSAPI_SEARCH = [{prop: 'apiName',label: '接口名称'},{prop: 'apiUrl',label: '接口网址'},{prop: 'apiUser',label: '接口账号'}]
export const SMSAPIACCOUNT = [{prop: 'smsSign',label: '短信签名'},{prop: 'accountUser',label: '用户接口账号'},{prop: 'accountPwd',label: '用户接口密码'}]
export const SMSAPIACCOUNT_SEARCH = [{prop: 'smsSign',label: '短信签名'},{prop: 'accountUser',label: '用户接口账号'}]
export const FACTORY = [{prop: 'factoryName',label: '工厂名称'},{prop: 'factoryLogo', label: '工厂LOGO', img: 'img'},{prop: 'openHours',label: '营业时间'},{prop: 'contactPerson', label: '联系人姓名'},{prop: 'contactPhone',label: '联系人电话'}]
export const FACTORY_SEARCH = [{prop: 'factoryName',label: '工厂名称'},{prop: 'contactPerson',label: '联系人姓名'},{prop: 'contactPhone',label: '联系人电话'}]